// Mock data for Musician Biography Page

export const musicianData = {
  name: "Bu İşte Bir Serserilik Var",
  subtitle: "",
  heroImage: "https://customer-assets.emergentagent.com/job_musician-showcase-5/artifacts/5roe3923_IMG_1676.jpeg",
  logoImage: "https://customer-assets.emergentagent.com/job_musician-showcase-5/artifacts/1jfoqtwy_IMG_1692.png",
  
  // Music streaming platforms
  musicLinks: [
    {
      name: "Spotify",
      url: "https://open.spotify.com/track/1nWtyyE8cphLhVna8YdNwq?si=UKE07k0BRhmn7Cmi48iDtA",
      logo: "https://customer-assets.emergentagent.com/job_musician-showcase-5/artifacts/p9w8n9fy_IMG_1730.png"
    },
    {
      name: "YouTube Music",
      url: "https://music.youtube.com/watch?v=iNfkvyQcNyM&si=jpuwjIAOvEcV3am6",
      logo: "https://customer-assets.emergentagent.com/job_musician-showcase-5/artifacts/5fllq88y_IMG_1729.png"
    }
  ],
  
  biography: [
    "90'ların ortalarından itibaren Ankara ve İstanbul'un Rock ve Metal müzik sahnesinde aktif olarak çeşitli gruplarda yer aldım; vokalist, gitarist, davulcu, besteci ve söz yazarı olarak farklı rollerde çeşitli prodüksiyonlarda bulundum. Yıllar boyunca bir çok grupla sahne alarak canlı performans deneyimi yakalama şansım oldu. 2000 yılında, Türkiye'de o dönemin ilk ve tek Hard Rock Cafe'sinde sahne alan bir Metallica Tribute grubunda vokal ve gitar görevini üstlendim.",
    
    "2000'lerin ortalarından itibaren canlı performanslara ara vererek odağımı beste, söz yazımı ve aranjmana yönelttim. Bu süreçte Türkiye'nin yanı sıra Almanya ve İsveç'ten müzisyen ve gruplarla prodüksiyonlar gerçekleştirdim.",
    
    "Bu yeni proje, yılların birikimiyle şekillenen kişisel bir yolculuk — bir anlamda \"One Man Project\". Hem geçmişten bugüne taşınmasını önemsediğim yerli ve yabancı eserlerin kendi yorumumla yeniden hayat bulduğu Cover çalışmalarını, hem de özgün bestelerimi bir araya getirecek. Yıllar içinde tanıştığım değerli müzisyen dostlarımın katkılarıyla bu proje gelişmeye devam ediyor.",
    
    "Temelde amaç basit: paylaşmak, birbirimize ilham olmak ve müziğin içimizdeki o derin yerini bir yolculuk olarak canlı tutmak."
  ],
  
  contact: {
    email: "producer@buistebirserserilikvar.com",
    social: [
      {
        name: "Instagram",
        url: "https://www.instagram.com/buistebirserserilikvar?igsh=ZzUzODZwMWw5NjNv",
        icon: "Instagram"
      },
      {
        name: "TikTok",
        url: "https://www.tiktok.com/@buistebirserseril",
        icon: "Music2"
      }
    ]
  }
};
